import React, { useEffect, useState } from "react";
import Layout from "containers/LayoutV2";
import configsRole from "utils/configsRole";
import "react-dropdown/style.css";
import { TableDanhSach } from "./TableDanhSach";
import { SearchBarDesktop } from "./SearchBarDesktop";
import LoaiPhieuThuChiApi from "service/QuanTriHeThong/LoaiPhieuThuChi/LoaiPhieuThuChiApi";
import StoreApi from "service/phanQuyenApi";
import UserApi from "service/userApi";

export const LoaiPhieuThuChi = () => {
  const initPhanQuyen = {
    loaiphieuthuchi: false,
    themmoi: false,
    sua: false,
    xoa: false,
    khoa: false,
    mo: false,
  };
  const [phanQuyen, setPhanQuyen] = useState(initPhanQuyen);
  const [loading, setLoading] = useState(true);
  const initialDataSearch = {
    sSearch: "",
    sCreatedUser: "",
    iPageIndex: 1,
    iPageSize: 20,
  };
  const [dataSearch, setDataSearch] = useState(initialDataSearch);
  const [listDanhSach, setListDanhSach] = useState({
    List: [],
    iTotal: 0,
    iPageSize: 20,
    iPageIndex: 1,
  });
  const [isLoadingList, setIsLoadingList] = useState(false);

  const handleSearch = React.useCallback(
    (search = dataSearch) => {
      const fullSearch = { ...initialDataSearch, ...search };
      setIsLoadingList(true);
      LoaiPhieuThuChiApi.getList(fullSearch)
        .then((res) => {
          if (res && res.status === 200) {
            setListDanhSach({
              List: res.data.List || [],
              iTotal: res.data.iTotal || 0,
              iPageSize: fullSearch.iPageSize || 20,
              iPageIndex: fullSearch.iPageIndex || 1,
            });
          } else {
            setListDanhSach({
              List: [],
              iTotal: 0,
              iPageSize: fullSearch.iPageSize || 20,
              iPageIndex: fullSearch.iPageIndex || 1,
            });
          }
        })
        .catch(() => {
          setListDanhSach({
            List: [],
            iTotal: 0,
            iPageSize: fullSearch.iPageSize || 20,
            iPageIndex: fullSearch.iPageIndex || 1,
          });
        })
        .finally(() => setIsLoadingList(false));
    },
    [dataSearch]
  );

  const handleReloadList = () => {
    handleSearch();
  };

  React.useEffect(() => {
    if (!loading && phanQuyen.loaiphieuthuchi) {
      handleSearch({ ...dataSearch, iPageIndex: 1 });
    }
  }, [loading, phanQuyen.loaiphieuthuchi]);

  const LoadPhanQuyen = () => {
    setLoading(true);
    StoreApi.getAllQuyen()
      .then((response) => {
        if (response.status === 200) {
          const getRole = (code) =>
            response.data.some(
              (e) => e.ModuleCode?.toUpperCase() === code.toUpperCase()
            );
          setPhanQuyen({
            loaiphieuthuchi: getRole(configsRole.sRole.loaiphieuthuchi),
            themmoi: getRole(
              configsRole.sRole.cauhinhphieuthuchi_themmoi
            ),
            sua: getRole(configsRole.sRole.cauhinhphieuthuchi_sua),
            xoa: getRole(configsRole.sRole.cauhinhphieuthuchi_xoa),
            khoa: getRole(configsRole.sRole.cauhinhphieuthuchi_khoa),
            mo: getRole(configsRole.sRole.cauhinhphieuthuchi_mo),
          });
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    document.title = "Loại phiếu thu chi | Phần mềm quản lý cầm đồ Morman";
    LoadPhanQuyen();
  }, []);

  // if (loading) return null;

  return (
    <Layout>
      {phanQuyen.loaiphieuthuchi === true ? (
        <div id="form-repeater" className="p-1">
          <div className="row header justify-content-start ml-1">
            <img
              src="/app-assets/images/icon-cau-hinh.png"
              alt="Mẫu hợp đồng"
            />
            <h1 className="text-info-home mb-1">Loại phiếu thu chi</h1>
          </div>
          <div className="ml-1 mr-1 mt-1">
            <SearchBarDesktop
              dataSearch={dataSearch}
              setDataSearch={setDataSearch}
              onSearch={handleSearch}
            />
          </div>
          <div className="p-1">
            <TableDanhSach
              phanQuyen={phanQuyen}
              listDanhSach={listDanhSach}
              isLoading={isLoadingList}
              dataSearch={dataSearch}
              setDataSearch={setDataSearch}
              onReload={handleReloadList}
              onSearch={handleSearch}
            />
          </div>
        </div>
      ) : (
        <div id="form-repeater" className="p-1">
          <div className="d-flex align-items-center">
            <i
              className="fa fa-receipt text-info-home"
              style={{ fontSize: "38px", borderRadius: "70%" }}
              aria-hidden="true"
            />
            <h1 className="text-info-home mb-0 ms-2 fw-bold">
              Loại phiếu thu chi
            </h1>
          </div>
          <span
            style={{
              textAlign: "center",
              color: "red",
              display: "flex",
              justifyContent: "center",
            }}
          >
            Bạn không có quyền truy cập chức năng này.
          </span>
        </div>
      )}
    </Layout>
  );
};
